@if (steps().length > 0) {
    <button class="btn btn-transparent-rounded mb-2" role="button"
        [attr.aria-expanded]="showSteps()" aria-controls="agentStepsDetails" (click)="toggleSteps()">
        <div class="text-thin">{{ showSteps() ? 'Hide Details' : 'See Details' }}</div>
        <div class="collapse-chevron align-self-center"></div>
    </button>

    <div [class.collapse]="!showSteps()" [class.show]="showSteps()" id="agentStepsDetails" [class.mb-2]="showSteps()">
        <ul class="list-steps">
            @for (step of renderedSteps(); track $index) {
                <li class="list-steps-item" [class.complete]="!streaming() || !$last">
                    <div class="list-steps-title">
                        @if (step.url) {
                            <a class="text-underline text-blue" [href]="step.url" target="_blank">{{ step.title }}</a>
                        } @else {
                            {{ step.title }}
                        }
                    </div>
                    @if (step.visibleItems.length) {
                        @if (step.visibleItems[0].kind === 'file') {
                            <div class="d-flex flex-wrap align-items-center">
                                @for (item of step.visibleItems; track item.url) {
                                    <a class="plate-container d-inline-flex" [href]="item.url" target="_blank">
                                        <div class="plate plate-thin plate-noshadow plate-white">
                                            <div class="plate-header width-full">
                                                <div class="plate-title min-width-0">
                                                    <div class="plate-title-icon">
                                                        <svg ycnIcon name="icon-overview"></svg>
                                                    </div>
                                                    <div class="plate-title-name min-width-0 text-ellipsis">{{ item.title }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                }
                                @if (step.hiddenItemCount) {
                                    <span class="text-small text-gray-60">+{{ step.hiddenItemCount }} more</span>
                                }
                            </div>
                        } @else {
                            <div class="d-flex flex-wrap align-items-center gap-1">
                                @for (item of step.visibleItems; track item.url) {
                                    <a class="text-small text-blue d-inline-flex align-items-center" [href]="item.url" target="_blank">
                                        <span>{{ item.title }}</span>
                                        <svg ycnIcon name="icon-export" class="ml-1 fill-current"></svg>
                                    </a>
                                }
                                @if (step.hiddenItemCount) {
                                    <span class="text-small text-gray-60">+{{ step.hiddenItemCount }} more</span>
                                }
                            </div>
                        }
                    }
                    <div class="list-steps-description" [innerHTML]="step.descriptionHtml"></div>
                </li>
            }

            @if (!streaming() && turnComplete()) {
                <li class="list-steps-item has-icon complete">
                    <div class="list-steps-item-icon">
                        <svg ycnIcon name="icon-check-circle" class="text-green fill-current"></svg>
                    </div>
                    <div class="list-steps-title">Done</div>
                </li>
            }
        </ul>
    </div>
}
